import {game_5002} from "./game_5002";

function game_5003()
{

}

game_5003.odd_map  = {
  "A":[0,0,0.5,1.5,2.5],
  "K":[0,0,0.4,1.2,2],
  "Q":[0,0,0.3,0.9,1.5],
  "J":[0,0,0.2,0.6,1],
  "P":[0,0,0.1,0.3,0.5],
  "R":[0,0,0.1,0.3,0.5],
  "D":[0,0,0.05,0.15,0.25],
  "C":[0,0,0.05,0.15,0.25],

};
game_5003.mul_array  = [
  [1,2,3,5],
  [2,4,6,10]
]

export {
  game_5003
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5003.js